import { render, staticRenderFns } from "./add-document-modal.vue?vue&type=template&id=d4a9f476&"
import script from "./add-document-modal.vue?vue&type=script&lang=js&"
export * from "./add-document-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports